import { Navigate, Outlet, RouteObject } from "react-router";
import { OfferIndexPage } from "./_components/offer-index-page";
import { OfferRoute } from "./[offerId]/offer-route";
import { OfferDataRoute } from "./[offerId]/data/offer-data-route";
import { OfferPricingRoute } from "./[offerId]/pricing/offer-pricing-route";
import { OfferFilesRoute } from "./[offerId]/files/offer-files-route";
import { OfferScopeOfWorksRoute } from "./[offerId]/scope-of-works/offer-scope-of-works-route";
import { OfferContractsRoute } from "./[offerId]/contracts/offer-contracts-route";
import { omniOfferContractRoutes } from "./[offerId]/contracts/contracts-routes";

// A contract of the offer is a document of its own: its page is a sibling
// of the offer page, not rendered inside it.
export const omniOffersRoutes: RouteObject[] = [
  {
    index: true,
    element: <OfferIndexPage />,
  },
  {
    path: ":offerId",
    element: <Outlet />,
    children: [
      {
        element: <OfferRoute />,
        children: [
          {
            index: true,
            element: <Navigate to="data" replace />,
          },
          {
            path: "data",
            element: <OfferDataRoute />,
          },
          {
            path: "pricing",
            element: <OfferPricingRoute />,
          },
          {
            path: "scope-of-works",
            element: <OfferScopeOfWorksRoute />,
          },
          {
            path: "files",
            element: <OfferFilesRoute />,
          },
          {
            path: "contracts",
            element: <OfferContractsRoute />,
          },
        ],
      },
      ...omniOfferContractRoutes,
    ],
  },
];
